import React from "react";
import CuadroTorneosPais from "./CuadroTorneosPais.js";
import styles from "./PrincipalPais.module.css";

const PrincipalPais = (props) => {
  const datosElegidos = props.datosElegidos;

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.titulo}`}>{datosElegidos.pais && datosElegidos.pais.nombre}</div>
      <div className={`${styles.contenedorCuadros}`}>
        <CuadroTorneosPais pais={datosElegidos.pais} titulo="Ultimos campeones" />
      </div>
    </div>
  );
};

export default PrincipalPais;